<template>
    <div id="bonus" v-on:click="exit">
        <img id="raio" :src="$url + 'img/coleta/raios_desafio.png'">
        <img id="star" :src="$url + 'img/coleta/estrelas_desafio.png'">
        <img id="icon" :src="$url + 'img/coleta/icone_desafio.png'">
        <transition name="fade">
            <div v-if="show" id="box">
                <h3 v-if="itens_count_day <= 30">Passou de fase</h3>
                <h3 v-if="itens_count_day > 30">Missão encerrada</h3>
                <span><a href="#"><img :src="$url + 'img/fechar.png'"></a></span>
                <div v-if="itens_count_day <= 30" id="text">
                    Parabéns, você acaba de ganhar 100 pontos por ter desbloqueado a 2ª fase.<br><br><br>

                    Agora que você já é um grande defensor da Cidade Agrinho, os desafios ficam
                    ainda maiores.<br>
                    Percorra o mapa, elimine as ameaças e participe dos desafios para ganhar mais
                    pontos.
                </div>
                <div v-if="itens_count_day > 30" id="text">
                    Tudo parece muito mais tranquilo na cidade!<br><br><br>
                    Parabéns, você acaba de ganhar 200 pontos por ter concluído a 2ª fase.<br><br>

                    Agora é hora de recuperar as energias, estudar e se preparar para novas missões amanhã!
                </div>


            </div>
        </transition>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
        name: "InitInfoComponent",
        data() {
            return {
                show: false
            }
        },
        computed: {
            ...mapGetters(['item', 'itens', 'itens_red', 'itens_frase', 'itens_count_day'])
        },
        methods: {
            yes() {
                window.removeEventListener('keyup', this.keyUpEventHandler);
                this.$parent.focusGame();
                this.$parent.view_bonus = false;
            },
            exit() {
                window.removeEventListener('keyup', this.keyUpEventHandler);
                this.$parent.focusGame();
                this.$parent.view_bonus = false;
            },
            keyUpEventHandler(e) {
                if (e.key == "Escape") {
                    this.exit();
                }
            }
        },
        mounted() {
            this.show = true;
            window.addEventListener('keyup', this.keyUpEventHandler);
        }
    }
</script>
<style scoped>
    #bonus {
        background-color: rgba(0, 0, 0, .5);
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 8;
    }
    #raio
    {
        height: 701px;
        left: calc(50% - 350px);
        position: absolute;
        top: calc(50% - 350px);
        width: 701px;
    }
    #star
    {
        height: 585px;
        left: calc(50% - 292px);
        position: absolute;
        top: calc(50% - 292px);
        width: 585px;
    }
    #icon
    {
        height: 175px;
        left: calc(50% - 80px);
        position: absolute;
        top: calc(50% - 317px);
        width: 198px;
    }
    #box
    {
        background-color: #fff;
        border-bottom: solid 70px #9dca26;
        border-radius: 30px;
        box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
        box-sizing: border-box;
        color: #777;
        display: block;
        height: auto;
        left: calc(50% - 150px);
        min-height: 400px;
        padding: 10px;
        position: absolute;
        text-align: center;
        top: calc(50% - 200px);
        width: 300px;
    }
    h3
    {
        background-color: #9dca26;
        border-bottom: solid 2px rgba(0, 0, 0, .05);
        border-radius: 15px;
        box-shadow: 0 -1px 0 rgba(255, 255, 255, .5);
        box-sizing: border-box;
        color: white;
        margin: -30px auto;
        padding: 15px;
        width: 180px;
    }
    span
    {
        position: absolute;
        right: -30px;
        top: -30px;
    }
    #current_item
    {
        margin-top: 50px;
        text-align: center;
    }
    #text
    {
        font-size: 16px;
        margin-top: 55px;
    }
    

    #points_info
    {
        bottom: -80px;
        left: calc(50% - 52px);
        margin-top: 15px;
        position: absolute;
        
    }
    #points_info > ul > li
    {
        color: white;
        display: inline-block;
        font-family: 'Paper Cutout';
        font-size: 50px;
        list-style: none;
        vertical-align: middle;
    }

    .btn-01
    {
        background-color: #fff;
        border-radius: 37px;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, .2);
        box-sizing: border-box;
        color: #9dca26 !important;
        display: inline-block;
        font-family: 'Paper Cutout';
        font-size: 60px;
        height: 58px;
        line-height: 34px;
        padding: 12px 15px;
        text-align: center;
        width: 90%;
    }
    .btn-01 > a
    {
        position: absolute;
    }
    .rot
    {
        transform: rotate(180deg);
    }
    .fade-enter-active, .fade-leave-active {
        top: calc(50% - 110px);
        opacity: 1;
        transition: all .5s ease-out;
    }
    .fade-enter, .fade-leave-to {
        top: 50%;
        opacity: 0;
    }

    @media screen and (max-width: 980px)
    {
        #box
        {
            left: 10%;
            width: 80%;
        }
    }
</style>